import { makeStyles } from "@fluentui/react-components";

const useStyleUtils = makeStyles({
    dBlock: {
        display: 'block'
    },
    dFlex: {
        display: 'flex'
    },
    dInline: {
        display: 'inline'
    },
    dInlineBlock: {
        display: 'inline-block'
    },
    dNone: {
        display: 'none'
    },
    w25: {
        width: '25%'
    },
    w50: {
        width: '50%'
    },
    w75: {
        width: '75%'
    },
    w100: {
        width: '100%'
    },
    h25: {
        height: '25%'
    },
    h50: {
        height: '50%'
    },
    h75: {
        height: '75%'
    },
    h100: {
        height: '100%'
    },
    m0: {
        margin: 0
    },
    mx0: {
        marginLeft: 0,
        marginRight: 0
    },
    my0: {
        marginTop: 0,
        marginBottom: 0
    },
    mbAuto: {
        marginBottom: 'auto'
    },
    mb0: {
        marginBottom: 0
    },
    mb1: {
        marginBottom: '.25rem'
    },
    mb2: {
        marginBottom: '.5rem'
    },
    mb3: {
        marginBottom: '1rem'
    },
    mb4: {
        marginBottom: '1.5rem'
    },
    mb5: {
        marginBottom: '3rem'
    },
    mtAuto: {
        marginTop: 'auto'
    },
    mt0: {
        marginTop: 0
    },
    mt1: {
        marginTop: '.25rem'
    },
    mt2: {
        marginTop: '.5rem'
    },
    mt3: {
        marginTop: '1rem'
    },
    mt4: {
        marginTop: '1.5rem'
    },
    mt5: {
        marginTop: '3rem'
    },
    mlAuto: {
        marginLeft: 'auto'
    },
    ml0: {
        marginLeft: 0
    },
    ml1: {
        marginLeft: '.25rem'
    },
    ml2: {
        marginLeft: '.5rem'
    },
    ml3: {
        marginLeft: '1rem'
    },
    ml4: {
        marginLeft: '1.5rem'
    },
    ml5: {
        marginLeft: '3rem'
    },
    mrAuto: {
        marginRight: 'auto'
    },
    mr0: {
        marginRight: 0
    },
    mr1: {
        marginRight: '.25rem'
    },
    mr2: {
        marginRight: '.5rem'
    },
    mr3: {
        marginRight: '1rem'
    },
    mr4: {
        marginRight: '1.5rem'
    },
    mr5: {
        marginRight: '3rem'
    },
    p0: {
        padding: 0
    },
    px0: {
        paddingLeft: 0,
        paddingRight: 0
    },
    px0i: {
        paddingLeft: "0 !important",
        paddingRight: "0 !important"
    },
    py0: {
        paddingTop: 0,
        paddingBottom: 0
    },
    pb0: {
        paddingBottom: 0
    },
    pb1: {
        paddingBottom: '.25rem'
    },
    pb2: {
        paddingBottom: '.5rem'
    },
    pb3: {
        paddingBottom: '1rem'
    },
    pb4: {
        paddingBottom: '1.5rem'
    },
    pb5: {
        paddingBottom: '3rem'
    },
    pt0: {
        paddingTop: 0
    },
    pt1: {
        paddingTop: '.25rem'
    },
    pt2: {
        paddingTop: '.5rem'
    },
    pt3: {
        paddingTop: '1rem'
    },
    pt4: {
        paddingTop: '1.5rem'
    },
    pt5: {
        paddingTop: '3rem'
    },
    pl0: {
        paddingLeft: 0
    },
    pl1: {
        paddingLeft: '.25rem'
    },
    pl2: {
        paddingLeft: '.5rem'
    },
    pl3: {
        paddingLeft: '1rem'
    },
    pl4: {
        paddingLeft: '1.5rem'
    },
    pl5: {
        paddingLeft: '3rem'
    },
    pr0: {
        paddingRight: 0
    },
    pr1: {
        paddingRight: '.25rem'
    },
    pr2: {
        paddingRight: '.5rem'
    },
    pr3: {
        paddingRight: '1rem'
    },
    pr4: {
        paddingRight: '1.5rem'
    },
    pr5: {
        paddingRight: '3rem'
    },
    textLeft: {
        textAlign: 'left'
    },
    textCenter: {
        textAlign: 'center'
    },
    textRight: {
        textAlign: 'right'
    },
    textJustify: {
        textAlign: 'justify'
    },
    alignItemsStart: {
        alignItems: 'start'
    },
    alignItemsCenter: {
        alignItems: 'center'
    },
    alignItemsEnd: {
        alignItems: 'end'
    },
    justifyContentStart: {
        justifyContent: 'start'
    },
    justifyContentCenter: {
        justifyContent: 'center'
    },
    justifyContentEnd: {
        justifyContent: 'end'
    },
    justifyContentBetween: {
        justifyContent: 'space-between'
    },
    cursorPointer: {
        cursor: 'pointer'
    }
});

export default useStyleUtils;